import { DetailsTabMenu } from '@/components/details';
import { clientRoute } from '@/features/dashboard/clients/routes/clientRoute.ts';
import { clientTabLinks } from '@/features/dashboard/bookingChanges/routes/detailsTabs.ts';

/** Goły adres zapisującego: menu kafli na telefonie, „Informacje” szeroko. */
const ClientTabMenu = () => {
  const { clientId } = clientRoute.useParams();
  const search = clientRoute.useSearch();

  return <DetailsTabMenu tabs={clientTabLinks(clientId, search)} />;
};

export default ClientTabMenu;
